import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GeneralService } from "../general.service";

@Component({
  selector: "app-dist-dashboard",
  templateUrl: "./dist-dashboard.component.html",
  styleUrls: ["./dist-dashboard.component.css"],
})
export class DistDashboardComponent implements OnInit {
  constructor(private router: Router, private gs: GeneralService) {}

  roleId: number;

  ngOnInit() {
    this.roleId = +sessionStorage.getItem("roleId");
  }

  p

  // expenditure(){
  //   this.router.navigate(['distExpDashboard']);
  // }

  // addTraining(){
  //   this.router.navigate(['addTraining']);
  // }

  addKabhiData() {
    this.router.navigate(["addPatientData"]);
  }

 
}
